const initialData = {
  id: '',
  email: '',
  event: '',
  value: 0,
  created: '',
}

export interface IUserLevel {
  EntryId: any
  Email: string
  Level: number
}

export type IModel = typeof initialData

export type TEventName = 'login' | 'add_partner' | 'change_preferred_phone'

export const create = (data?: Partial<IModel>): IModel => ({
  ...initialData,
  ...data,
})
